// frontend/src/components/profile/SavedItemsList.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { savedApi } from '../../api/saved';
import helpers from '../../utils/helpers';
import SaveButton from '../common/SaveButton';
import { FaHeartBroken, FaInfoCircle } from 'react-icons/fa';

function SavedItemsList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchItems();
  }, []);

  const fetchItems = async () => {
    try {
      const data = await savedApi.getSavedItems();
      setItems(data);
    } catch (err) {
      console.error("Error fetching saved items:", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="text-center py-10">Loading saved items...</div>;

  return (
    <div>
        {/* --- TOOLKIT --- */}
        <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-6 rounded-r-lg shadow-sm flex items-start gap-3">
            <FaInfoCircle className="text-blue-500 text-xl mt-1 flex-shrink-0" />
            <div>
                <h4 className="font-bold text-blue-800 text-sm">Your Wishlist</h4>
                <p className="text-sm text-blue-700">
                    Keep track of vehicles and parts you are interested in. Prices and availability are updated in real-time.
                </p>
            </div>
        </div>

        {items.length === 0 ? (
            <div className="text-center py-10 bg-gray-50 rounded-lg border border-dashed border-gray-300">
            <FaHeartBroken className="mx-auto text-gray-300 text-4xl mb-3" />
            <p className="text-gray-500 mb-4">You haven't saved any items yet.</p>
            <Link to="/vehicles/browse" className="text-primary hover:underline">Browse Vehicles</Link>
            </div>
        ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {items.map((item) => {
                // Determine link based on type
                const linkPath = item.item_type === 'vehicle' 
                ? `/vehicles/${item.item_id}` 
                : `/parts/${item.item_id}`;

                return (
                <div key={item.id} className="bg-white border border-gray-200 rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow relative group">
                    
                    {/* Image */}
                    <Link to={linkPath} className="block h-40 bg-gray-100 overflow-hidden relative">
                    <img 
                        src={item.image || 'https://via.placeholder.com/300'} 
                        alt={item.itemname} 
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                    <div className="absolute top-2 right-2">
                        <SaveButton itemId={item.item_id} itemType={item.item_type} />
                    </div>
                    </Link>

                    {/* Details */}
                    <div className="p-4">
                    <div className="text-xs text-gray-500 uppercase font-bold mb-1">
                        {item.item_type}
                    </div>
                    <Link to={linkPath} className="block font-bold text-gray-800 hover:text-primary mb-2 line-clamp-1">
                        {item.itemname}
                    </Link>
                    <div className="flex justify-between items-center">
                        <span className="text-primary font-bold">
                        {helpers.formatCurrency(item.price, 'NGN')}
                        </span>
                        {item.location && (
                        <span className="text-xs text-gray-500">{item.location}</span>
                        )}
                    </div>
                    </div>
                </div>
                );
            })}
            </div>
        )}
    </div>
  );
}

export default SavedItemsList;